/**
 * Workaround for FoxEcom Modvia <image-lazy> race.
 *
 * vendor.js is deferred, so by the time the custom element registers and
 * upgrades existing <img is="image-lazy"> nodes, the image's `load` event has
 * often already fired. The theme's connectedCallback then attaches a `load`
 * listener that never resolves, leaving the .media-wrapper stuck on the
 * `loading` class — and theme.css hides any img inside a .loading wrapper
 * (`opacity: 0`). Result: blank cards until something mutates `src` (e.g. a
 * swatch hover) and the MutationObserver path re-runs handleLazyLoad.
 *
 * This shim sweeps the DOM at the moments stuck wrappers are most likely:
 * after first paint, after window load, and on a small delay to catch
 * srcset re-fetches. It only ever PROMOTES wrappers from loading→loaded,
 * so it can't fight the theme.
 */
(function () {
  'use strict';

  function unstick() {
    const imgs = document.querySelectorAll('img[is="image-lazy"]');
    for (const img of imgs) {
      if (!img.complete) continue;
      const wrapper = img.closest('.media-wrapper');
      if (!wrapper) continue;
      if (wrapper.classList.contains('loading')) {
        wrapper.classList.remove('loading');
        wrapper.classList.add('loaded');
      }
      if (!img.classList.contains('loaded')) {
        img.classList.add('loaded');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', unstick, { once: true });
  } else {
    unstick();
  }
  window.addEventListener('load', unstick);
  setTimeout(unstick, 500);
  setTimeout(unstick, 2000);

  // Also unstick after dynamic content swaps (collection filters, infinite
  // scroll). Watch the products grid for new card insertions.
  const grid = document.getElementById('ProductGridContainer') || document.body;
  if (grid && 'MutationObserver' in window) {
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length) { unstick(); return; }
      }
    });
    obs.observe(grid, { childList: true, subtree: true });
  }
})();
